import { observer } from "mobx-react-lite";
import MainLayout from "../MainLayout";
import { useNavigate } from "react-router-dom";
import { VerticalLayout } from "../../common/common-layout";
import { TitleLargeMedium } from "../../common/common-text";
import { useEffect, useState } from "react";
import CustomerReport from "../../model/homepage/CustomerReport";
import { formatDateToYMD } from "../../common/utils/DateUtils";
import BTBox from "../../common/components/BTBox";
import BTList from "../../common/components/board/BTList";
import { GridRowParams } from "@mui/x-data-grid";
import { fetchCustomerReportList } from "../../service/HomepageService";

const CustomerReports = () => {
    return (
        <MainLayout>
            <CustomerReportsBody />
        </MainLayout>
    );
};

export default CustomerReports;

const CustomerReportsBody = observer(() => {
    const navigate = useNavigate();
    const [customerReports, setCustomerReports] = useState<CustomerReport[]>([]);
    const [selectedRows, setSelectedRows] = useState<number[]>([]); 

    useEffect(() => {
        async function loadData() {
            const reports = await fetchCustomerReportList();

            setCustomerReports(reports);
        }

        loadData();
    }, []);


    const columns = [
        { field: 'id', headerName: '번호', width: 80, headerAlign: 'center', align: 'center' },
        { field: 'title', headerName: '제목', flex: 1, headerAlign: 'center', align: 'left' },
        { field: 'requestorName', headerName: '작성자', width: 120, headerAlign: 'center', align: 'center' },
        { field: 'email', headerName: '이메일', width: 240, headerAlign: 'center', align: 'center' },
        { field: 'createdAt', headerName: '접수일', width: 110, headerAlign: 'center', align: 'center' },
        { field: 'replyCompletedYn', headerName: '답변 여부', width: 120, headerAlign: 'center', align: 'center' },
    ];

    const rows = customerReports.map((customerReport, index) => ({
        id: customerReports.length - index,
        title: customerReport.title,
        requestorName: customerReport.requestorName,
        dateOfBirth: customerReport.dateOfBirth,
        email: customerReport.email,
        replyCompletedYn: customerReport.replyCompletedYn ? '✅' : '❌',
        createdAt: formatDateToYMD(customerReport.createdAt),
        originalCustomerReport: customerReport,
    }));

    const handleRowClick = (params: GridRowParams): void => {
        const matchedCustomerReport = params.row.originalCustomerReport;
        if (matchedCustomerReport) {
            navigate('/homepage/reports/detail', { state: matchedCustomerReport });
        }
    };

    return (
        <VerticalLayout height={'auto'} paddingLeft={36} paddingRight={36}>
            <TitleLargeMedium>BB열린소리 관리</TitleLargeMedium>
            <BTBox height='24px' />
            <BTList
                rows={rows}
                columns={columns}
                handleRowClick={handleRowClick}
                selectedRows={selectedRows} 
                setSelectedRows={setSelectedRows}
                pageStateKey="homepage.reports.list"
            />
        </VerticalLayout>
    );
});
